// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__12ge7","label":"styles_label__3iY83"};